import React,{Component} from 'react';
//import { connect } from 'react-redux';
import { Modal } from "react-bootstrap";

export default class LoginSessionExpired extends Component {
  render() {
    return (
      <Modal show={false} 
        onHide={()=>this.handleClose()} 
        backdrop="static"
        className="modal fade select-files"
      >
        <Modal.Header>
          <Modal.Title>Your session has timed out.</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Click <a ui-sref="login">here</a> to login.</p>
        </Modal.Body>  
        <Modal.Footer></Modal.Footer>
      </Modal>
    );
  }
}